import React from 'react';
// ANTD
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/css';
// COMPONENTS
import OfflinePlaceholder from 'components/common/OfflinePlaceholder';
import OnboardingOverlay from 'components/common/OnboardingOverlay';
import AppMenu from './AppMenu';
import AppHeader from './AppHeader';
import MobileHeader from './MobileHeader';
//  LIB
import AccountHelpers from 'lib/helpers/AccountHelpers';

const { Content, Sider, Header } = Layout;

class AppLayout extends React.PureComponent {
  state = {
    current: this.props.location.pathname || null,
    collapsed: this.props.windowWidth < 768,
  };

  handleLogoutClick = async () => {
    try {
      await AccountHelpers.handleLogout();
    } catch (err) {
      console.log(err);
    }
    return window.location.reload();
  };

  onToggleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  handleClick = e => {
    this.setState({ open: false });

    if (e.key === 'logout') {
      return this.handleLogoutClick();
    }

    if (e.key === '/app/help') {
      return window.open(
        'https://hey-ned-help.helpscoutdocs.com/',
        '_blank', // <- This is what makes it open in a new window.
      );
    }

    // if on mobile, close the sidebar after the user selects a tab
    if (this.props.windowWidth < 768) {
      this.onToggleCollapse();
    }

    return this.props.history.push(e.key);
  };

  render() {
    const mobileSiderStyle = {
      position: 'absolute',
      bottom: 0,
      top: 0,
      zIndex: 1000,
    };

    if (this.props.windowWidth < 768) {
      return (
        <div>
          <Layout>
            <Header
              style={{
                borderBottom: '2px solid #efefef',
                height: 75,
                background: '#FFF',
                padding: 0,
              }}
            >
              <MobileHeader
                currentUser={this.props.currentUser}
                handleClick={this.handleClick}
                collapsed={this.state.collapsed}
                onToggleCollapse={this.onToggleCollapse}
              />
            </Header>
            <Content style={{ background: '#FBFCFC' }}>
              <div
                style={{
                  background: '#FBFCFC',
                  minHeight: '65vh',
                  height: '100%',
                }}
              >
                {this.props.children}
                {/* Check if user has seen onboarding video, if not, show the onboarding video overlay */}
                {!window.localStorage.getItem('userHasSeenVideo') && <OnboardingOverlay />}
              </div>
            </Content>
          </Layout>
        </div>
      );
    }
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          collapsedWidth={this.props.windowWidth > 768 ? 79 : 0} // on desktop the sibar hangs out 79px, on mobile we hide the sidebar completely like a hamburger slider menu
          trigger={null}
          collapsed={this.state.collapsed}
          collapsible
          style={!this.state.collapsed && this.props.windowWidth < 768 ? mobileSiderStyle : {}}
          className="sider"
        >
          <AppMenu handleClick={this.handleClick} {...this.props} />
        </Sider>
        <Layout>
          <Header
            style={{
              borderBottom: '2px solid #efefef',
              height: 75,
              background: '#FFF',
              padding: 0,
            }}
          >
            <AppHeader
              currentUser={this.props.currentUser}
              handleClick={this.handleClick}
              collapsed={this.state.collapsed}
              // sliderPadding={SLIDER_PADDING}
              onToggleCollapse={this.onToggleCollapse}
            />
          </Header>
          <Content style={{ background: '#FBFCFC' }}>
            <div
              style={{
                background: '#FBFCFC',
                minHeight: '65vh',
                height: '100%',
              }}
            >
              {this.props.children}
              {/* Check if user has seen onboarding video, if not, show the onboarding video overlay */}
              {!window.localStorage.getItem('userHasSeenVideo') && <OnboardingOverlay />}
            </div>
          </Content>
        </Layout>

        <OfflinePlaceholder />
      </Layout>
    );
  }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/components/layout/AppLayout/index.js